import axios from 'utils/axios'
import { VERSIONS } from 'utils/version'

export const access = (appid, cpf) => axios.get(`${VERSIONS.V1}/access/${appid}/${cpf}`)
